import { RouterProvider } from 'react-router-dom';
import { router } from './routes/router';

/**
 * App — root application shell. AuthProvider, QueryClientProvider, and
 * Toaster live in main.tsx so every route can share auth + query context.
 */
export default function App() {
  return <RouterProvider router={router} future={{ v7_startTransition: true }} />;
}
